export default __webpack_public_path__ + "static/media/AceLogo.1555dcde.png";